import React from "react";
import { Row, Col, Button, ProgressBar } from "react-bootstrap";

interface Props {
  id?: string;
  children?: React.ReactNode;
  headerIcon: string;
  headerText: string;
  saveText?: string;
  deleteText?: string;
  headerActionContent?: React.ReactNode;
  cancelFunction?: () => void;
  deleteFunction?: () => void;
  saveFunction?: () => void;
  className?: string;
  isSubmitting?: boolean;
  ariaLabelDelete?: string;
  ariaLabelSave?: string;
  submitProgress?: number;
}

export const InputBox: React.FC<Props> = (props: Props) => {
  let buttons = [];

  if (props.cancelFunction) buttons.push(<Col key="cancel"><Button variant="warning" block onClick={props.cancelFunction} disabled={props.isSubmitting}>Cancel</Button></Col>);
  if (props.deleteFunction) buttons.push(<Col key="delete"><Button id="delete" variant="danger" block aria-label={props.ariaLabelDelete} onClick={props.deleteFunction} disabled={props.isSubmitting}>{props.deleteText || "Delete"}</Button></Col>);
  if (props.saveFunction) {
    if (props.submitProgress && props.submitProgress > 0 && props.submitProgress < 100) {
      buttons.push(<Col key="save"><ProgressBar striped animated variant="success" now={props.submitProgress} /></Col>);
    } else buttons.push(<Col key="save"><Button type="submit" variant="success" block aria-label={props.ariaLabelSave} onClick={props.saveFunction} disabled={props.isSubmitting}>{props.saveText || "Save"}</Button></Col>);
  }

  let classNames = ["inputBox"];
  if (props.className) classNames.push(props.className);

  return (
    <div id={props.id} className={classNames.join(" ").trim()}>
      <div className="header" data-cy="header">
        <Row>
          <Col xs={6}><i className={props.headerIcon}></i> {props.headerText}</Col>
          <Col xs={6} style={{ textAlign: "right" }}>{props.headerActionContent}</Col>
        </Row>
      </div>
      <div className="content">{props.children}</div>
      <div className="footer">
        <Row>{buttons}</Row>
      </div>
    </div>
  );
}